module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-800.f78c45ac.eot";